import script from "./WorkflowEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowEditor.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowEditor.vue?vue&type=style&index=0&id=bf514b30&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf514b30"]])

export default __exports__